import { IconButton, InputAdornment, TextField, TextFieldProps } from "@mui/material";
import CircularLoading from "./CircularLoading";
import DynamicIcon from "./DynamicIcon";
import { useEffect, useState } from "react";
import useDebounce from "../../common/hooks/use_debounce";
import { CloseRounded } from "@mui/icons-material";

interface Props extends TextFieldProps<"outlined"> {
  loading?: boolean
  checked?: boolean
  failed?: boolean
  onChangeDebounce?: (value: string) => void
  value?: unknown
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> | undefined
}


function Input({ loading = false, checked = false, failed = false, onChangeDebounce, value, onChange, ...props }: Props) {

  const debounceChange = useDebounce(onChangeDebounce, 500)
  const [lastValue, setLastValue] = useState(value)

  useEffect(() => {
    if (onChangeDebounce && value != lastValue) {
      debounceChange(value)
      setLastValue(value)
    }
  }, [value])

  return (
    <div className="w-full flex items-center">
      <TextField
        fullWidth
        size="small"
        value={value}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end" sx={{ visibility: value ? "visible" : "hidden" }}>
                <IconButton edge="end" onClick={() => {
                  if (onChange) {
                    onChange({ target: { value: "" } } as React.ChangeEvent<HTMLInputElement>);
                  }
                }}>
                  <CloseRounded />
                </IconButton>
              </InputAdornment>
            )
          }
        }}
        onChange={(x) => {
          if (onChange) {
            onChange(x)
          }
        }}
        {...props} />
      <div className={`${props.helperText ? "mb-5" : ""} ${loading || checked || failed ? "ml-2" : ""}`}>
        {
          (loading == true) &&
          <CircularLoading size={25} />
        }
        {
          (checked == true && loading == false) &&
          <DynamicIcon nameIcon="CheckRounded" className="text-primary-green" size={35} />
        }
        {
          (failed == true && loading == false) &&
          <DynamicIcon nameIcon="CloseRounded" className="text-red-500" size={35} />
        }
      </div>
    </div>

  );
}

export default Input;